export default {
  aboutTag: "Acerca de Nosotros",
  title1: "La Historia Detrás de",
  title2: "My Food Truck Agency",
  subtitle:
    "Descubre cómo empezamos y por qué nos apasiona ayudar a los emprendedores de comida a prosperar en nuestra comunidad",
  ourStoryTag: "Nuestra Historia",
  storyTitle1: "Nacido de la Frustración.",
  storyTitle2: "Construido para Operadores.",
  paragraph1:
    "Creamos My Food Truck Agency porque vimos a demasiados emprendedores de comida con talento rendirse — no porque su comida no fuera lo suficientemente buena, sino porque el proceso de permisos de California era demasiado abrumador para resolverlo solo.",
  paragraph2:
    "El fundador pasó meses ayudando a un amigo a navegar los códigos de salud del Condado de Orange, los requisitos de comisaría y las regulaciones ciudad por ciudad. Lo que debería haber tomado semanas se prolongó durante meses — y ese amigo casi renuncia.",
  paragraph3:
    "Esa experiencia dejó algo claro: se necesitaba una agencia dedicada para los operadores de food trucks del Condado de Orange. Alguien de su lado que ya conociera cada formulario, cada tarifa y cada inspector. Eso es exactamente lo que construimos.",
  founderName: "El Equipo OCFTA",
  founderRole: "Especialistas en Food Trucks del Condado de Orange",
  founderYears: "1 año sirviendo a operadores del Condado de Orange",
  milestonesTitle: "Nuestro Primer Año — Hito por Hito",
  today: "Hoy",
  milestones: [
    {
      month: "Mes 1",
      title: "Abrimos Nuestras Puertas",
      description:
        "My Food Truck Agency se fundó en el Condado de Orange con una misión: hacer que sea facilísimo para los emprendedores de comida navegar el complejo panorama de permisos de California.",
    },
    {
      month: "Mes 3",
      title: "Primeros 10 Clientes con Permiso",
      description:
        "En nuestro primer trimestre ayudamos a 10 operadores de food trucks a obtener con éxito sus permisos de Instalación de Comida Móvil en ciudades del Condado de Orange como Anaheim, Santa Ana e Irvine.",
    },
    {
      month: "Mes 6",
      title: "Expansión a las 34 Ciudades del Condado de Orange",
      description:
        "Construimos relaciones con departamentos de salud, comisarías y oficinas municipales en las 34 ciudades del Condado de Orange — ofreciendo a los clientes una verdadera ventanilla única para cada jurisdicción.",
    },
    {
      month: "Mes 9",
      title: "Lanzamiento del Programa de Construcción de Camiones",
      description:
        "Nos asociamos con fabricantes de food trucks certificados para ofrecer consultas de construcción de principio a fin — conectando a los clientes con fabricantes verificados que ya entienden los requisitos del código de salud del Condado de Orange.",
    },
    {
      month: "Año 1",
      title: "Seguimos Aquí. Seguimos Creciendo.",
      description:
        "Un año después, estamos orgullosos de cada operador al que hemos ayudado a despegar. Estamos ampliando nuestros servicios y redoblando esfuerzos para hacer del Condado de Orange el mejor lugar para operar un food truck.",
    },
  ],
  ctaText: "Sé parte del próximo capítulo.",
  bookSession: "Reservar una Sesión",
};